<template>
    <footer class="footer-landing">
        <!-- Subscribe CTA Section -->
        <section class="subscribe-cta">
        <div class="subscribe-content">
            <h2>Subscribe Now for Free</h2>
            <p>Sign up now for free and take the first step toward landing your dream job!</p>
            <button class="inquire-btn">Inquire</button>
        </div>
        </section>

        <!-- Footer Links Section -->
        <div class="footer-main">
        <img class="footer-logo" src="@/assets/img/purple-logo.png" alt="Surpriz.ing logo" />
            <ul class="footer-links">
                <li><router-link to="/landing" class="menu-item">Home</router-link></li>
                <li><router-link to="#" class="menu-item">How It Works</router-link></li>
                <li><router-link to="/about-us" class="menu-item">About us</router-link></li>
                <li><router-link to="#" class="menu-item">Blogs</router-link></li>
                <li><router-link to="/faq-new" class="menu-item">FAQ</router-link></li>
                <li><router-link to="#" class="menu-item">Contact Us</router-link></li>
            </ul>
        </div>

        <hr class="footer-divider" />

        <!-- Copyright Section -->
        <div class="footer-bottom">
        <p class="copyright">© 2023 Surpriz.ing. All rights reserved.</p>
        <ul class="policy-links">
            <li>Privacy Policy</li>
            <li>Terms and Conditions</li>
            <li>Cookie Policy</li>
        </ul>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'FooterLanding'
}
</script>

<style scoped>
.footer-landing {
    background-color: #FAFAFA;
    font-family: 'Inter', sans-serif;
    padding-top: 40px;
}

/* CTA */
.subscribe-cta {
    background: linear-gradient(103.95deg, #c69dff, #6587ff);
    border-radius: 20px;
    padding: 80px 20px;
    position: relative;
    text-align: center;
    overflow: hidden;
    margin: 40px auto;
}
.subscribe-cta::before {
    content: "";
    background-image: url('/path/to/your-waves.svg');
    background-repeat: no-repeat;
    background-size: cover;
    position: absolute;
    inset: 0;
    opacity: 0.15;
    z-index: 0;
}
.subscribe-content {
    position: relative;
    z-index: 1;
    max-width: 700px;
    margin: 0 auto;
    color: white;
}
.subscribe-content h2 {
    font-size: 36px;
    font-weight: 600;
    margin-bottom: 16px;
}
.subscribe-content p {
    font-size: 18px;
    line-height: 150%;
    margin-bottom: 32px;
}
.inquire-btn {
    background-color: white;
    color: #171717;
    border-radius: 999px;
    padding: 12px 24px;
    border: none;
    font-weight: 500;
    font-size: 16px;
    cursor: pointer;
    transition: transform 0.2s ease;
}
.inquire-btn:hover {
    transform: translateY(-2px);
}

/* Main Footer Section */
.footer-main {
    text-align: center;
    padding: 40px 20px 20px;
}
.footer-logo {
    height: 110px;
    width: 130px;
    margin-bottom: 24px;
}
.footer-links {
    list-style: none;
    display: flex;
    justify-content: center;
    gap: 32px;
    padding: 0;
    margin: 0;
    font-size: 14px;
    font-weight: 500;
    color: #171717;
    flex-wrap: wrap;
}
.footer-links li {
    font-weight: 500px;
    font-size: 16px;
    line-height: 24px;
    cursor: pointer;
    transition: color 0.2s ease;
}

.footer-links .menu-item {
    color: #171717 !important; /* Force black-ish text */
    text-decoration: none;
}

.footer-links .menu-item:hover {
    text-decoration: underline;
}


/* Divider */
.footer-divider {
    border: none;
    border-top: 1px solid #e5e5e5;
    margin: 32px 48px;
}

/* Bottom Bar */
.footer-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    padding: 0 48px 40px;
    font-size: 12px;
    color: #555;
}
.policy-links {
    list-style: none;
    display: flex;
    gap: 24px;
    margin: 0;
    padding: 0;
}
.policy-links li {
    cursor: pointer;
    text-decoration: underline;
}


@media (max-width: 768px) {
    .subscribe-cta {
        width: 364px;
        height: 300px;
        padding: 60px 21px;
    }
    .subscribe-content h2{
        font-size: 28px;
        font-weight: 500;
    }
    .subscribe-content p{
        font-size: 16px;
    }
    .footer-logo{
        width: 74px;
        height: 56px;
    }
    .footer-links {
        list-style: none;
        display: grid;
        grid-template-columns: repeat(2, auto); /* 2 columns */
        justify-content: center;
        row-gap: 16px; /* space between rows */
        column-gap: 64px; /* space between columns */
        padding: 0;
        margin: 0;
        font-size: 14px;
        font-weight: 500;
        color: #171717;
    }

}

@media (max-width: 768px) {
    .footer-landing {
        padding: 20px;
    }
    .subscribe-cta {
        padding: 40px 16px;
    }
    .subscribe-content h2 {
        font-size: 24px;
    }
    .subscribe-content p {
        font-size: 14px;
    }
    .inquire-btn {
        padding: 10px 20px;
        font-size: 14px;
    }
    .footer-links {
        flex-direction: column;
        align-items: center;
        gap: 16px;
    }
}

</style>
